/**
 * 全站音频试听互斥 —— 同一时刻只让一个 `<audio>` 出声(0813 测试反馈)。
 *
 * 现场(爱民):「如果第一个不喜欢,我在他还没播放完我就点了第二个,然后就出现 2 个声音都在报读」。
 * 截图里两个播放器同时处于播放态。原因是试听墙用的是裸 `<audio controls>` ——
 * 浏览器原生控件之间互不知情,谁也不会替谁暂停。
 *
 * 挑音色这件事的本质是**逐个对比**,连点两三个是主路径而不是误操作,所以这层必须由我们兜。
 *
 * 用法:给每个 `<audio>` 加 `onPlay={pauseOtherAudio}`。故意做成一个裸函数而不是 hook ——
 * 试听器散在创建页/声音库/BGM 面板/成片详情多处,有的还在列表里循环渲染,
 * 裸函数哪儿都能挂,不引入 ref 管理成本。
 *
 * 只记「上一个在播的元素」,不做全局注册表:DOM 卸载后这个引用最多是一个已 detach 的元素,
 * 对它 `pause()` 是无害的 no-op,不会泄漏也不会拦住新的播放。
 */

let playing: HTMLAudioElement | null = null;

/** 挂到 `<audio onPlay>`:开播时把上一个正在播的暂停掉。 */
export function pauseOtherAudio(event: { currentTarget: HTMLAudioElement }): void {
  const el = event.currentTarget;
  if (playing && playing !== el && !playing.paused) {
    playing.pause();
  }
  playing = el;
}

/** 测试用:清掉记住的那个元素(避免用例之间互相影响)。 */
export function __resetExclusiveAudio(): void {
  playing = null;
}
